import { Component, OnInit } from '@angular/core';
import { AuthorizationAwareComponent } from '../../core/authorization-aware-component';
import { Store } from '@ngrx/store';
import { AppState } from '../../app-state';
import { AnalyticsEventType } from '../../google-analytics/analytics-event-type';

@Component({
  standalone: false,
  selector: 'mtn-administration',
  templateUrl: './administration.component.html',
  styleUrls: ['./administration.component.scss']
})
export class AdministrationComponent extends AuthorizationAwareComponent implements OnInit {

  AnalyticsEventType = AnalyticsEventType;

  constructor(protected ngrxStore: Store<AppState>) {
    super(ngrxStore);
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  onAuthorizationChange(): void {
    //Do nothing
  }

  onAuthorizationInit() {
    //Do nothing
  }

}
